import { Component, ReactNode } from "react";

export class ServiceQuoteFlowErrorBoundary extends Component<
    ServiceQuoteFlowErrorBoundaryProps,
    ServiceQuoteFlowErrorBoundaryState
> {
    constructor(props: ServiceQuoteFlowErrorBoundaryProps) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(): ServiceQuoteFlowErrorBoundaryState {
        return { hasError: true };
    }

    render() {
        if (this.state.hasError) {
            return (
                <div
                    className="flex h-screen w-screen items-center justify-center bg-white p-6 text-center"
                    role="alert"
                    aria-live="assertive"
                >
                    <p className="text-lg text-gray-800">An error occurred.</p>
                </div>
            );
        }
        return this.props.children;
    }
}


interface ServiceQuoteFlowErrorBoundaryProps {
    children: ReactNode;
}

interface ServiceQuoteFlowErrorBoundaryState {
    hasError: boolean;
}
